var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import { childrenExist, createShorthandFactory, customPropTypes, UIComponent, commonPropTypes, } from '../../lib';
import { chatMessageBehavior } from '../../lib/accessibility';
import Text from '../Text/Text';
import Slot from '../Slot/Slot';
/**
 * A chat message represents a single statement communicated to a user.
 */
var ChatMessage = /** @class */ (function (_super) {
    __extends(ChatMessage, _super);
    function ChatMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionHandlers = {
            // prevents default FocusZone behavior, e.g., in ChatMessageBehavior, it prevents FocusZone from using arrow keys as navigation (only Tab key should work)
            preventDefault: function (event) {
                event.preventDefault();
            },
        };
        return _this;
    }
    ChatMessage.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, accessibility = _a.accessibility, rest = _a.rest, styles = _a.styles;
        var _b = this.props, author = _b.author, children = _b.children, content = _b.content, mine = _b.mine, timestamp = _b.timestamp;
        var childrenPropExists = childrenExist(children);
        var className = childrenPropExists ? cx(classes.root, classes.content) : classes.root;
        return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, accessibility.keyHandlers.root, rest, { className: className }), childrenPropExists ? (children) : (React.createElement(React.Fragment, null,
            !mine &&
                Text.create(author, { defaultProps: { size: 'small', styles: styles.author } }),
            Text.create(timestamp, {
                defaultProps: { size: 'small', styles: styles.timestamp, timestamp: true },
            }),
            Slot.create(content, { defaultProps: { styles: styles.content } })))));
    };
    ChatMessage.className = 'ui-chat__message';
    ChatMessage.displayName = 'ChatMessage';
    ChatMessage.propTypes = __assign({}, commonPropTypes.createCommon({ content: 'shorthand' }), { accessibility: PropTypes.oneOfType([PropTypes.object, PropTypes.func]), author: customPropTypes.itemShorthand, mine: PropTypes.bool, timestamp: customPropTypes.itemShorthand });
    ChatMessage.defaultProps = {
        accessibility: chatMessageBehavior,
        as: 'div',
    };
    return ChatMessage;
}(UIComponent));
ChatMessage.create = createShorthandFactory(ChatMessage, 'content');
export default ChatMessage;
